<p class="c-p-xs" [innerHTML]="context.text"></p>
<div class="c-d-flex c-m-top-md">
  <button class="c-btn c-btn-secondary" (click)="cancel()">Cancel</button>
</div>
